// src/components/home/UpdateCard.js
import React, { useState } from 'react';
import { Utensils, Moon, Activity, Image, BookOpenCheck, Apple, Scale, Milk, Baby, PencilRuler, MessageCircle } from 'lucide-react';
import { useAtom } from 'jotai';
import { appConstants } from '../../atomstore/store';

const UpdateCard = ({ update, setSelectedPhoto }) => {

    const [thumbError, setThumbError] = useState(false);
    const [constants] = useAtom(appConstants)
    const getIcon = (type) => {
        if (['Breakfast', 'Snacks', 'Lunch'].includes(type)) return Utensils;
        if (type === 'Sleep') return Moon;
        if (type === 'Fruits') return Apple;
        if (type === 'Image') return Image;
        if (type === 'Measurement') return PencilRuler;
        if (type === 'Attendance') return BookOpenCheck;
        if (type === 'Milk') return Milk;
        if (type === 'Diaper') return Baby;
        if (type === 'Message') return MessageCircle;



        return Activity;
    };

    const getGradient = (type) => {
        if (['Breakfast', 'Snacks', 'Lunch'].includes(type)) return 'from-orange-400 to-red-500';
        if (type === 'Sleep') return 'from-purple-400 to-indigo-500';
        if (type === 'Image') return 'from-green-400 to-blue-500';
        if (type === 'Attendance') return 'from-amber-700 to-yellow-900';
        if (type === 'Measurement') return 'from-yellow-400 to-yellow-600';
        if (type === 'Milk') return 'from-cyan-400 to-blue-500';
        if (type === 'Diaper') return 'from-orange-400 to-red-500';

        return 'from-cyan-400 to-blue-500';
    };

    const Icon = getIcon(update.type);

    return (
        <div
            id={update.type === 'nap' ? 'nap-section' : update.type === 'food' ? 'meals-section' : undefined}
            className="flex items-start space-x-3"
        >
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-gradient-to-br ${getGradient(update.type)}`}>
                <Icon className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
                <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-500">{update.time}</span>
                    <span className="text-sm font-semibold text-gray-800">{update.type}</span>
                </div>
                {update.type === "Image" ? (
                    !thumbError ? (
                        <img
                            src={"https://fp-portal-uploads.s3.ap-southeast-1.amazonaws.com/uploads/daily_uploads" + "/" + update.message}
                            alt="Update"
                            className="size-64  rounded-xl mt-2 object-cover shadow-sm"
                            onError={() => setThumbError(true)}   // fallback trigger
                        />
                    ) : (
                        <div className="w-full size-52 rounded-xl mt-2 bg-gray-200 
                        flex items-center justify-center text-gray-500 text-sm shadow-sm">
                            Failed to load
                        </div>
                    )
                ) : (
                    <p className="text-sm text-gray-600 mt-1">{update.message}</p>
                )}
                {update.hasPhoto && (
                    <div className="mt-2 grid grid-cols-3 gap-2">
                        {[1, 2, 3].map((imgIdx) => (
                            <button
                                key={imgIdx}
                                onClick={() => setSelectedPhoto({
                                    title: update.title,
                                    time: update.time,
                                    image: imgIdx,
                                    desc: 'Children engaged in ' + update.title.toLowerCase()
                                })}
                                className="aspect-square rounded-xl overflow-hidden cursor-pointer hover:scale-105 transition shadow-md"
                            >
                                <div className={`w-full h-full bg-gradient-to-br ${imgIdx === 1 ? 'from-amber-200 via-orange-200 to-rose-300' :
                                    imgIdx === 2 ? 'from-blue-200 via-cyan-200 to-teal-300' :
                                        'from-purple-200 via-pink-200 to-fuchsia-300'
                                    } flex items-center justify-center relative`}>
                                    <div className="absolute inset-0 bg-black bg-opacity-10"></div>
                                    <div className="text-center z-10">
                                        <div className="text-4xl mb-1">
                                            {imgIdx === 1 ? '👧🏽' : imgIdx === 2 ? '👦🏽' : '👧🏾'}
                                        </div>
                                        <div className="text-xs text-gray-700 font-medium px-2">
                                            {imgIdx === 1 ? 'Playing' : imgIdx === 2 ? 'Learning' : 'Creating'}
                                        </div>
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UpdateCard;